import {createFeatureSelector} from '@ngrx/store';
import {ItemsReq} from '@app/core/models';

// selectors

export const getFilterState = createFeatureSelector<{
  filter: ItemsReq;
}>('filter');
